import { loadImage } from "../../../helpers/Image.helper";

export function generateTwinkle(width, height) {
	return Promise.all([
		loadImage('effects/star_lightning.png'),
	]).then(images => {
		//snowflake particles
		let mp = 50; //max particles
		let particles = [];
		for (var i = 0; i < mp; i++) {
			particles.push({
				x: Math.random() * width, //x-coordinate
				y: Math.random() * height, //y-coordinate
				size: Math.random() * 30 + 30, //radius
				d: Math.random() * mp, //density
				o: Math.random() * Math.PI, // opacity
				rf: Math.sign(Math.random() - .5) * (Math.random() * 0.5 + .5), // opacity
				img: images[Math.floor(Math.random() * images.length)],
			});
		}

		let angle = 0;

		return {
			mp,
			particles,
			draw: (p, ctx) => {
				const rot = (p.size + angle) * p.rf;
				ctx.translate(p.x, p.y);
				ctx.rotate(rot);
				ctx.globalAlpha = Math.abs(Math.sin(p.o));
				if (p.img) {
					ctx.drawImage(p.img, -(p.size / 2), -(p.size / 2), p.size, p.size);
				}
				ctx.globalAlpha = 1;
				ctx.rotate(-rot);
				ctx.translate(-p.x, -p.y);
			},
			update: () => {
				angle += Math.PI / 60;

				//Function to move the snowflakes
				//angle will be an ongoing incremental flag. Sin and Cos functions will be applied to it to create vertical and horizontal movements of the flakes
				for (var i = 0; i < mp; i++) {
					var p = particles[i];
					p.o = (p.o + .05);

					if (p.o > Math.PI) {
						p.o -= Math.PI;
						p.x = Math.random() * width;
						p.y = Math.random() * height;
					}
				}
			},
		}
	});
}
